<template lang="pug">
div(class='pt-[40px] border-t')
  Overlay(unique-key='yotpoFilters' mode='LIGHT')
    template(#header)
      div Filters

    div(class='flex flex-col gap-8 items-center h-80 px-16')
      YotpoReviewsRatingsDropdown(class='w-full' :selected-rating='selectedRating' @on-rating-change='selectRating')
      YotpoReviewsMediaButton(class='w-full flex' :with-media='withMedia' @on-media-change='selectMedia')

  div(class='flex basis-4/5')
    slot(name='search')
    YotpoReviewsRatingsDropdown(
      class='hidden lg:block w-44 mr-2'
      :selected-rating='selectedRating'
      @on-rating-change='selectRating'
    )
    YotpoReviewsMediaButton(class='hidden lg:flex w-44' :with-media='withMedia' @on-media-change='selectMedia')

    div(class='lg:hidden')
      img(src='/images/yotpo/filters.svg' class='ml-3 mt-3 w-3 h-3 absolute' width='12' height='12' alt='dropdown arrow')
      button(
        class='pl-9 first-line:mr-2 w-44 rounded-full border border-gray-light hover:border-black text-left text-sm h-9'
        @click='$overlay.open("yotpoFilters")'
      ) Filters

  YotpoReviewsTopics(:yotpo-id='yotpoId' :selected-topics='selectedTopics' @on-select-topic='selectTopic')
  YotpoReviewsSortDropdown(:selected-sort='selectedSort' @on-sort-change='selectSort')
</template>

<script setup lang="ts">
const { yotpoId, selectedTopics, selectedSort, selectedRating, withMedia } = defineProps<{
  yotpoId: string
  selectedTopics: string[]
  selectedSort: string
  selectedRating: string
  withMedia: boolean
}>()

const emit = defineEmits(['onSelectTopic', 'onSortChange', 'onRatingChange', 'onMediaChange'])

function selectTopic(value: string) {
  emit('onSelectTopic', value)
}

function selectRating(value: string) {
  emit('onRatingChange', value)
}

function selectSort(value: string) {
  emit('onSortChange', value)
}

function selectMedia(value: boolean) {
  emit('onMediaChange', value)
}
</script>
